import {
  type BackgroundComplementaryScale,
  type BorderComplementaryScale,
  ColorScales,
  type GraphicsScale,
} from '../../../types/theme';
import { backgroundComplementary } from '../color/background-complementary';
import { borderComplementary } from '../color/border-complementary';
import { graphics } from '../color/graphics';

type ColorScaleType =
  | BackgroundComplementaryScale
  | BorderComplementaryScale
  | GraphicsScale;

export const getColorScaleAsArray = (colorScale: ColorScales) => {
  let scale: ColorScaleType = backgroundComplementary;

  if (colorScale === ColorScales.backgroundGraphics) {
    scale = graphics;
  }

  if (colorScale === ColorScales.borderComplementary) {
    scale = borderComplementary;
  }

  return Object.values(scale);
};
